import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';

const HOME_PAGE = "/mails"; // Path to the home page | CAN BE CHANGED
const LOGIN_PAGE = "/login"; // Path to the login page | CAN BE CHANGED

/**
 * Auth component, handles the redirection after login 
 * 
 * @returns {JSX.Element} Auth component
 */
function Auth() {
    const { instance } = useMsal();
    const navigate = useNavigate();

    /**
     * Handles the redirection after login
     * it will check if the login was successful and redirect to the home page
     * if the login was not successful, it will redirect to the login page
     */
    useEffect(() => {
        const handleRedirect = async () => {
            try {
                await instance.handleRedirectPromise();
                navigate(HOME_PAGE);
            } catch (error) {
                console.error("Erreur pendant la connexion : ", error);
                navigate(LOGIN_PAGE);
            }
        };

        handleRedirect();
    }, [instance, navigate]);

    return (
        <div>
            <h1>Redirection en cours...</h1>
            <p>Merci de patienter, nous finalisons votre connexion.</p>
        </div>
    );
}

export default Auth;